export class MovementBuilder {
    constructor(value) {
        this.value = value;
    }
    time(t) {
        this.value.time = t;
        return this;
    }
    restrict(area) {
        this.value.valid_from = area;
        return this;
    }
    fixed(target, relative = false) {
        this.value.fixed_target = relative ? { target: target, relative: true } : { target: target };
        this.value.offset = undefined;
        return this;
    }
    offset(offset) {
        this.value.offset = offset;
        this.value.fixed_target = undefined;
        return this;
    }
    orientation(orientation) {
        this.value.orientation = orientation;
        this.value.forced_orientation = undefined;
        return this;
    }
    forcedOrientation(orientation, relative = undefined) {
        this.value.orientation = "forced";
        this.value.forced_orientation = { dir: orientation, relative: relative };
        return this;
    }
    done() {
        return this.value;
    }
}
(function (MovementBuilder) {
    function init() {
        return move({ time: 1 });
    }
    MovementBuilder.init = init;
    function move(value) {
        return new MovementBuilder(value);
    }
    MovementBuilder.move = move;
    function offset(offset) {
        return init().offset(offset);
    }
    MovementBuilder.offset = offset;
    function fixed(target, relative = false) {
        return init().fixed(target, relative);
    }
    MovementBuilder.fixed = fixed;
})(MovementBuilder || (MovementBuilder = {}));
